import Vue from 'vue'

// Check if we're in a browser environment
if (process.client) {
  // Wrap in try-catch to handle any import errors gracefully
  try {
    // Try to import v-photoswipe first
    const { PhotoSwipe } = require('v-photoswipe')
    
    // Ensure PhotoSwipe is properly defined before registering
    if (PhotoSwipe && typeof PhotoSwipe === 'object') {
      Vue.component('vue-picture-swipe', PhotoSwipe)
      console.log('vue-picture-swipe loaded successfully with v-photoswipe')
    } else {
      throw new Error('PhotoSwipe component not properly exported')
    }
    
  } catch (error) {
    console.warn('v-photoswipe not available:', error.message)
    
    // Fallback to local implementation
    try {
      const VuePictureSwipe = require('./vue-picture-swipe/src/main.js').default
      
      if (VuePictureSwipe && typeof VuePictureSwipe === 'object') {
        Vue.component('vue-picture-swipe', VuePictureSwipe)
        console.log('vue-picture-swipe loaded successfully with local implementation')
      } else {
        throw new Error('Local VuePictureSwipe not properly exported')
      }
      
    } catch (fallbackError) {
      console.warn('Local vue-picture-swipe not available:', fallbackError.message)
      
      // Ultimate fallback - create a safe minimal component
      Vue.component('vue-picture-swipe', {
        props: {
          items: {
            type: Array,
            default: () => []
          },
          options: {
            type: Object,
            default: () => ({})
          },
          isOpen: {
            type: Boolean,
            default: false
          }
        },
        template: `
          <div v-if="isOpen" class="vue-picture-swipe-fallback" @click="close">
            <div class="fallback-content" @click.stop>
              <p>Galería no disponible</p>
              <button @click="close" class="close-btn">Cerrar</button>
            </div>
          </div>
        `,
        watch: {
          isOpen: {
            handler(newVal) {
              if (!newVal) {
                this.$emit('close')
              }
            },
            immediate: true
          }
        },
        methods: {
          close() {
            this.$emit('close')
          }
        },
        style: `
          .vue-picture-swipe-fallback {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 30000;
          }
          .fallback-content {
            background: white;
            padding: 20px;
            border-radius: 8px;
            text-align: center;
          }
          .close-btn {
            margin-top: 10px;
            padding: 8px 16px;
            background: #007bff;
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;
          }
        `
      })
      
      console.log('vue-picture-swipe loaded with minimal fallback component')
    }
  }
} else {
  // Server-side: register a no-op component
  Vue.component('vue-picture-swipe', {
    props: ['items', 'options', 'isOpen'],
    template: '<div></div>',
    serverPrefetch() {
      // Prevent any server-side rendering issues
      return Promise.resolve()
    }
  })
}


